// extracted by mini-css-extract-plugin
module.exports = {"policy":"IncentivesAndPolicy_policy__11leY"};